import { FormattedMessage } from 'react-intl';

import './style.scss';

interface IProps {
  accumulated: number;
  threshold: number;
  /** Optional: show "Almost there!" when progress >= 80% */
  showMicrocopy?: boolean;
}

export function WalletRewardProgressCompact(props: IProps) {
  const { accumulated, threshold, showMicrocopy = true } = props;
  if (threshold <= 0) return null;

  const progress = Math.min(100, (accumulated / threshold) * 100);
  const remaining = Math.max(0, Math.ceil(threshold - accumulated));
  const isAlmostThere = progress >= 80 && progress < 100;

  return (
    <div className="wallet-reward-progress-compact">
      <p className="wallet-reward-progress-compact__title">
        <FormattedMessage id="wallet.header.nextRewardProgress" />
      </p>
      <div className="wallet-reward-progress-compact__track">
        <div
          className="wallet-reward-progress-compact__fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="wallet-reward-progress-compact__label">
        <FormattedMessage
          id="wallet.header.progressLabel"
          values={{
            current: Math.floor(accumulated),
            target: Math.floor(threshold),
          }}
        />
      </p>
      {remaining > 0 && (
        <p className="wallet-reward-progress-compact__away">
          <FormattedMessage
            id="wallet.header.awayFromNext"
            values={{ count: remaining }}
          />
        </p>
      )}
      {showMicrocopy && (
        <p className="wallet-reward-progress-compact__microcopy">
          {isAlmostThere ? (
            <FormattedMessage id="wallet.header.almostThere" />
          ) : (
            <FormattedMessage id="wallet.header.keepTraveling" />
          )}
        </p>
      )}
    </div>
  );
}
